import axios from "axios"
import { asyncThunkOf } from "../../../common/utils/redux-helpers"
import { ReqStatus } from "../../../common/utils/utils"

export const resetDislikePreferences = asyncThunkOf<ReqStatus>("resetDislikePreferences", async () => {
    try {
        await axios.post<boolean>(`/private/debug/reset-dislike-preferences`)
        return ReqStatus.SUCCESS
    } catch (err) {
        console.error("could not reset dislike preferences", err)
        return ReqStatus.FAILED
    }
})

export const fetchChromaticUrl = asyncThunkOf<string>(
    "fetchChromaticUrl",
    async () => (await axios.get<string>("/private/debug/chromatic-url")).data
)
